import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Select nativo estilizado com o Design System.
 * Usado dentro de modais/drawers: não usa portal, então não conflita com o React
 * na remoção dos nós (erro removeChild/insertBefore).
 */
export function NativeSelect({ value, onChange, options = [], className, placeholder, ...rest }) {
  return (
    <div className="relative w-full min-w-0">
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={options.length === 0}
        className={cn(
          "flex h-10 w-full min-w-0 appearance-none truncate rounded-md border border-input bg-background px-3 py-2 pr-9 text-sm",
          "ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
          "disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        {...rest}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
    </div>
  );
}
